import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { graphqlRequest } from '../../../utils/graphqlRequest';
import { formatAUD } from '../../../utils/formatCurrency';
import '../styles/InventoryProducts.css';

const FIND_ITEM_HISTORY = `
  query FindItemHistory($itemId: String!) {
    findItemHistory(itemId: $itemId) {
      id
      previousQuantity
      previousAvailableQuantity
      previousPerItemCost
      previousDescription
      previousExpiryDate
      newQuantity
      newAvailableQuantity
      newPerItemCost
      newDescription
      newExpiryDate
      inputQuantity
      inputPerItemCost
      previousTotalCost
      newTotalCost
      updatedBy
      createdAt
    }
  }
`;

function formatDate(raw) {
  if (!raw) return '—';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

function money(value) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return formatAUD(n);
}

export default function ItemUpdateHistory({ item, onClose }) {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      if (!item?.id) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const data = await graphqlRequest(FIND_ITEM_HISTORY, {
          itemId: item.id,
        });
        setHistoryData(data?.findItemHistory || []);
      } catch (error) {
        toast.error(`Failed to load history: ${error.message}`);
        setHistoryData([]);
      } finally {
        setLoading(false);
      }
    };
    void fetchHistory();
  }, [item]);

  return (
    <div className="ip-overlay" onClick={onClose}>
      <div
        className="ip-modal ip-modal--detail"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="ip-modal-header">
          <h2>History — {item?.name || 'Product'}</h2>
          <button
            type="button"
            className="ip-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </header>
        <div className="ip-modal-body">
          {loading ? (
            <p className="ip-history-empty">Loading history…</p>
          ) : historyData.length === 0 ? (
            <p className="ip-history-empty">
              No movement history yet. Entries appear when stock is added,
              restocked, or the quantity is edited.
            </p>
          ) : (
            <ul className="ip-history-list">
              {historyData.map((row) => {
                const addedQty =
                  row.inputQuantity != null
                    ? Number(row.inputQuantity)
                    : (Number(row.newQuantity) || 0) -
                      (Number(row.previousQuantity) || 0);
                return (
                  <li key={row.id} className="ip-history-item">
                    <div className="ip-history-item-top">
                      <strong>{formatDate(row.createdAt)}</strong>
                      <span>{row.updatedBy || 'System'}</span>
                    </div>
                    <div className="ip-history-item-meta">
                      Qty change {addedQty > 0 ? '+' : ''}
                      {addedQty}
                      {' · '}on hand {row.newAvailableQuantity ?? '—'}
                      {' · '}cost {money(row.inputPerItemCost ?? row.newPerItemCost)}
                    </div>
                    {row.newDescription &&
                    row.newDescription !== row.previousDescription ? (
                      <div className="ip-history-item-meta">
                        {row.newDescription}
                      </div>
                    ) : null}
                  </li>
                );
              })}
            </ul>
          )}
          <div className="ip-modal-footer">
            <button type="button" className="ip-btn" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
